// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-navigation-entry.active .app-navigation-entry-icon{filter:var(--background-invert-if-bright)}`, "",{"version":3,"sources":["webpack://./src/views/Apps.vue"],"names":[],"mappings":"AAEC,wDACC,yCAAA","sourcesContent":["\n.app-navigation-entry.active {\n\t.app-navigation-entry-icon {\n\t\tfilter: var(--background-invert-if-bright);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
